<div class="dialog-content">
  <div class="estate-container">
    <div class="estate-text">
      <mat-icon class="icon">location_city</mat-icon>
      <h3>{{ 'label.estate' | locCap }}</h3>
    </div>
    <mat-form-field *ngIf="data.contextType === CT.ESTATE" class="hide-underline full-width">
      <mat-select [formControl]="estateForm" disableOptionCentering>
        <mat-option *ngFor="let estate of data.estates" [value]="estate.id">{{ estate.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <app-switch-context
      [estateControl]="estateForm"
      [contextType]="data.contextType"
      [contextData]="data.contextData"
      [estates]="data.estates"
    ></app-switch-context>
  </div>

  <div class="user-container">
    <button mat-flat-button type="button" class="full-width" (click)="showBrowserNotifications()">
      <mat-icon>notifications</mat-icon>
      <span>{{ 'browserNtf.panel.title' | loc }}</span>
    </button>
    <div class="language-select">
      <button class="language-button" [class.currentLang]="ls.currentLang === 'pl'" mat-menu-item (click)="setLanguage('pl')">
        <span class="flag-icon margin-right-5 flag-icon-pl"></span> Polski
      </button>
      <button class="language-button" [class.currentLang]="ls.currentLang === 'en'" mat-menu-item (click)="setLanguage('en')">
        <span class="flag-icon margin-right-5 flag-icon-gb"></span> English
      </button>
    </div>
    <app-user-actions (close)="close()"></app-user-actions>
  </div>
</div>
